module.exports = __webpack_public_path__ + "static/media/broken.d0357e0d.svg";